import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import toast from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import EditReviewPop from "../../../components/Modals/EditReviewPop";
import { Link } from "react-router-dom";
import {
  useDeleteRatingsMutation,
  useGetRatingsQuery,
} from "../../../store/services/ratings";

const RATING_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

const ManageStoreReview = () => {
  const [confirmation, setConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [bodyData, setBodyData] = useState({
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    pageNo: 1,
    search: "",
  });
  const { data: ratings, error, isLoading } = useGetRatingsQuery(bodyData);
  const [editModal, setEditModal] = useState(false);
  const [editReview, setEditReview] = useState(null);
  const [deleteReview] = useDeleteRatingsMutation();
  const [commentModal, setCommentModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState("");
  const handleConfirmation = () => setConfirmation(!confirmation);

  const confirmHandler = async () => {
    try {
      await deleteReview(deleteId).unwrap();
      setConfirmation(false);
      return toast.success("Ratings deleted successfully");
    } catch (error) {
      console.error("Failed to delete the Ratings:", error);
      toast.error("Failed to delete the Ratings");
    }
  };

  const handlePageChange = (selectedPage) => {
    setBodyData((prevState) => ({
      ...prevState,
      pageNo: selectedPage.selected + 1,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditReview((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = () => {
    setEditModal(false);
    toast.success("Review updated");
  };

  const handleEditRating = (newRating) => {
    setEditReview((prev) => ({ ...prev, rating: newRating }));
  };

  const handleViewComment = (comment) => {
    setSelectedComment(comment || "No comment available");
    setCommentModal(true);
  };

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        const startingIndex = (bodyData.pageNo - 1) * bodyData.limit;
        const serialNumber = startingIndex + key + 1;
        return <>{serialNumber < 10 ? `0${serialNumber}` : serialNumber}</>;
      },
    },
    {
      head: "Order Id",
      accessor: "orderId",
      component: (item) => (
        <span className="text-muted" style={{ fontSize: "0.875rem" }}>
          {item.orderId?.orderID || "N/A"}
        </span>
      ),
    },
    {
      head: "Customer Name",
      accessor: "customerName",
      component: (item) => (
        <p className="m-0 themeBlue fw-sbold">
          {item.userId?.name || item.userId?.firstName || "N/A"}
        </p>
      ),
    },
    {
      head: "Email",
      accessor: "email",
      component: (item) => (
        <p className="m-0 themeBlue fw-sbold">{item.userId?.email || "N/A"}</p>
      ),
    },
    // {
    //   head: "Comments",
    //   accessor: "comments",
    //   component: (item) => (
    //     <div className="d-flex align-items-center justify-content-center">
    //       {item.comments ? (
    //         <Button
    //           className="d-flex align-items-center justify-content-center commonBtn"
    //           size="sm"
    //           style={{ fontSize: "12px", padding: "4px 12px", minWidth: "60px" }}
    //           onClick={() => handleViewComment(item.comments)}
    //           title="View Comment"
    //         >
    //           View
    //         </Button>
    //       ) : (
    //         <span className="text-muted">No comments</span>
    //       )}
    //     </div>
    //   ),
    // },
    {
      head: "Status",
      accessor: "status",
      component: (item) => {
        const statusMap = {
          [RATING_STATUS.PENDING]: {
            text: "Pending",
            class: "badge bg-warning",
          },
          [RATING_STATUS.ACCEPTED]: {
            text: "Approved",
            class: "badge bg-success",
          },
          [RATING_STATUS.REJECTED]: {
            text: "Rejected",
            class: "badge bg-danger",
          },
        };
        const status = statusMap[item.status] || {
          text: "Unknown",
          class: "badge bg-secondary",
        };
        return <span className={status.class}>{status.text}</span>;
      },
    },
    {
      head: "Created At",
      accessor: "createdAt",
      component: (item) => (
        <>
          {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : "-"}
        </>
      ),
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <div className="actionBtn d-flex align-items-center gap-10">
          <Link
            to={`/manage-StoreReviews/${item?.orderId?._id}`}
            className="border-0 p-0"
            variant="transparent"
            title="View"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="13"
              viewBox="0 0 21 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.1269 0.379883C6.00023 0.379883 2.81476 3.30125 1.26883 5.0114C0.614598 5.73509 0.23969 6.2714 0.23969 6.2714C0.0900251 6.48573 0.0900251 6.77233 0.23969 6.98666C0.23969 6.98666 0.534721 7.40936 1.05152 8.0024C2.50253 9.6674 5.79632 12.8782 10.1269 12.8782C14.572 12.8782 17.9291 9.49839 19.3181 7.87307C19.7642 7.35098 20.0152 6.98666 20.0152 6.98666C20.1649 6.77233 20.1649 6.48573 20.0152 6.2714C20.0152 6.2714 19.7398 5.87467 19.2535 5.31173C17.8276 3.6621 14.5055 0.379883 10.1269 0.379883ZM10.1269 1.62996C13.8634 1.62996 16.9827 4.59581 18.3074 6.12852C18.5725 6.43529 18.5974 6.48424 18.7089 6.63143C18.605 6.76803 18.593 6.79697 18.3671 7.06124C17.0781 8.56964 13.9201 11.6281 10.1269 11.6281C6.43137 11.6281 3.34181 8.72873 1.99268 7.18081C1.70294 6.8484 1.67185 6.78672 1.55443 6.63143C1.69037 6.45001 1.77636 6.31473 2.19543 5.85135C3.63536 4.25828 6.60534 1.62996 10.1269 1.62996ZM10.1269 2.88004C8.06297 2.88004 6.38027 4.56274 6.38027 6.62663C6.38027 8.69036 8.06297 10.378 10.1269 10.378C12.1906 10.378 13.8783 8.69036 13.8783 6.62663C13.8783 4.56274 12.1906 2.88004 10.1269 2.88004ZM10.1269 4.13127C11.5152 4.13127 12.6282 5.23814 12.6282 6.62663C12.6282 8.01496 11.5152 9.12794 10.1269 9.12794C8.73837 9.12794 7.6315 8.01496 7.6315 6.62663C7.6315 5.23814 8.73837 4.13127 10.1269 4.13127Z"
                fill="#645C5C"
              />
            </svg>
          </Link>
          <Button
            className="border-0 p-0"
            variant="transparent"
            size="sm"
            onClick={() => {
              handleConfirmation();
              setDeleteId(item._id);
            }}
            title="Delete"
          >
            <span title="Delete">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="19"
                viewBox="0 0 17 19"
                fill="none"
              >
                <g clipPath="url(#clip0_0_1356)">
                  <path
                    d="M10.3149 14.4727C10.4807 14.4727 10.6397 14.4068 10.7569 14.2896C10.8741 14.1724 10.9399 14.0134 10.9399 13.8477V7.59766C10.9399 7.4319 10.8741 7.27292 10.7569 7.15571C10.6397 7.0385 10.4807 6.97266 10.3149 6.97266C10.1492 6.97266 9.99021 7.0385 9.873 7.15571C9.75579 7.27292 9.68994 7.4319 9.68994 7.59766V13.8477C9.68994 14.0134 9.75579 14.1724 9.873 14.2896C9.99021 14.4068 10.1492 14.4727 10.3149 14.4727ZM5.93994 14.4727C6.1057 14.4727 6.26467 14.4068 6.38188 14.2896C6.49909 14.1724 6.56494 14.0134 6.56494 13.8477V7.59766C6.56494 7.4319 6.49909 7.27292 6.38188 7.15571C6.26467 7.0385 6.1057 6.97266 5.93994 6.97266C5.77418 6.97266 5.61521 7.0385 5.498 7.15571C5.38079 7.27292 5.31494 7.4319 5.31494 7.59766V13.8477C5.31494 14.0134 5.38079 14.1724 5.498 14.2896C5.61521 14.4068 5.77418 14.4727 5.93994 14.4727ZM10.6274 2.28516C10.7932 2.28516 10.9522 2.21931 11.0694 2.1021C11.1866 1.98489 11.2524 1.82592 11.2524 1.66016C11.2524 1.4944 11.1866 1.33542 11.0694 1.21821C10.9522 1.101 10.7932 1.03516 10.6274 1.03516H5.62744C5.46168 1.03516 5.30271 1.101 5.1855 1.21821C5.06829 1.33542 5.00244 1.4944 5.00244 1.66016C5.00244 1.82592 5.06829 1.98489 5.1855 2.1021C5.30271 2.21931 5.46168 2.28516 5.62744 2.28516H10.6274Z"
                    fill="#EB5757"
                  />
                  <path
                    d="M1.25244 2.91016C1.08668 2.91016 0.92771 2.976 0.8105 3.09321C0.69329 3.21042 0.627441 3.3694 0.627441 3.53516C0.627441 3.70092 0.69329 3.85989 0.8105 3.9771C0.92771 4.09431 1.08668 4.16016 1.25244 4.16016H1.87744V15.6602C1.87744 17.0727 3.02744 18.2227 4.43994 18.2227H11.8149C13.2274 18.2227 14.3774 17.0727 14.3774 15.6602V4.16016H15.0024C15.1682 4.16016 15.3272 4.09431 15.4444 3.9771C15.5616 3.85989 15.6274 3.70092 15.6274 3.53516C15.6274 3.3694 15.5616 3.21042 15.4444 3.09321C15.3272 2.976 15.1682 2.91016 15.0024 2.91016H2.50244H1.25244ZM13.1274 4.16016V15.6602C13.1274 16.0083 12.9892 16.3421 12.743 16.5882C12.4969 16.8344 12.163 16.9727 11.8149 16.9727H4.43994C4.09185 16.9727 3.75801 16.8344 3.51186 16.5882C3.26572 16.3421 3.12744 16.0083 3.12744 15.6602V4.16016H13.1274Z"
                    fill="#EB5757"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_1356">
                    <rect
                      width="16"
                      height="18"
                      fill="white"
                      transform="translate(0.127441 0.628906)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </Button>
        </div>
      ),
    },
  ];

  // Use dynamic data from API response
  const storeReviews = ratings?.data || [];
  const totalCount = ratings?.totalcount || 0;

  return (
    <>
      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={confirmHandler}
        type="delete"
      />
      
      {/* Comment View Modal */}
      <Modal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            <p className="mb-0" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {selectedComment}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setCommentModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      
      <section className="manageusers py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Online Store Reviews
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap"></ul>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      {/* <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Export CSV
                      </Button> */}
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {isLoading ? (
                <div className="text-center">Loading...</div>
              ) : error ? (
                <div className="text-center text-danger">
                  Error loading data
                </div>
              ) : storeReviews.length > 0 ? (
                <TableLayout column={column} data={storeReviews} />
              ) : (
                <div className="text-center">No data Found</div>
              )}
              {storeReviews.length > 0 && (
                <CstmPagination
                  pageCount={Math.ceil(totalCount / bodyData.limit)}
                  onPageChange={handlePageChange}
                  itemsPerPage={bodyData.limit}
                  totalItems={totalCount}
                  currentPage={bodyData.pageNo}
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageStoreReview;
